import { computed } from "vue";
import { useRoute } from "vue-router";
import classNames from "classnames";
import RouteNames from "@/router/RouteNames";

export function useCustomRoute() {
  const route = useRoute();

  const meta = computed(() => route.meta || {});
  const requiresAuth = computed(() => meta.value.requiresAuth || false);
  const header = computed(() => meta.value.header || {});
  const headerClass = computed(() =>
    getClassNameResolver(route)(header.value.className)
  );
  const headerTitle = computed(() => header.value.title);
  const footer = computed(() => meta.value.footer || {});
  const footerClass = computed(() =>
    getClassNameResolver(route)(footer.value.className)
  );

  const routeName = computed(() => route.name);
  const isMain = computed(() => route.name === RouteNames.MainView);
  const isMyPage = computed(() => route.path.startsWith("/gooduser/mypage"));

  const myPage = computed(() => meta.value.myPage || {});
  const myPageWrapper = computed(() => myPage.value.wrapper || {});
  const myPageClass = computed(() =>
    getClassNameResolver(route)(myPage.value.className)
  );
  const myPageWrapperClass = computed(() =>
    getClassNameResolver(route)(myPageWrapper.value.className)
  );

  const promotion = computed(() => meta.value.promotion || {});
  const promotionTitle = computed(() => promotion.value.title);

  return {
    route,
    requiresAuth,
    headerClass,
    headerTitle,
    footerClass,
    myPageClass,
    myPageWrapperClass,
    isMain,
    isMyPage,
    routeName,
    promotionTitle,
  };
}

function getClassNameResolver(route) {
  return (className) => {
    if (typeof className === "function") {
      return classNames(className(route)) || null;
    } else {
      return classNames(className) || null;
    }
  };
}
